import { IContactDetailDTO } from 'src/app/shared/model/contact-details-dto.model';

export interface ILanguage {
    id?: number;
    name?: string;
    contactDetails?: IContactDetailDTO[];
}

export class Language implements ILanguage {
    constructor(public id?: number, public name?: string, public contactDetails?: IContactDetailDTO[]) {}
}
